(function () {
  function revealAspDutiesCart() {
    if (!document.documentElement.hasAttribute('data-asp-duties-notice')) return;
    document.querySelectorAll('.asp-us-duties-cart').forEach(function (el) {
      el.classList.add('is-on');
    });
    var host = document.getElementById('upCart');
    if (!host) return;
    function mark(root) {
      if (!root) return;
      root.querySelectorAll('.asp-us-duties-cart').forEach(function (el) {
        el.classList.add('is-on');
      });
    }
    mark(host.shadowRoot);
    if (host.shadowRoot) {
      host.shadowRoot.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) mark(el.shadowRoot);
      });
    }
  }

  function bindAspDutiesCart() {
    if (typeof window.upcartSubscribeCartUpdated !== 'function') return false;
    window.upcartSubscribeCartUpdated(revealAspDutiesCart);
    return true;
  }

  revealAspDutiesCart();
  if (!bindAspDutiesCart()) {
    var wait = setInterval(function () {
      revealAspDutiesCart();
      if (bindAspDutiesCart()) clearInterval(wait);
    }, 500);
    setTimeout(function () {
      clearInterval(wait);
    }, 15000);
  }
})();
